<!--  Whatsapp Button  -->
<a class="{{ constants.gtm.css.contact }}" [href]="dataRedesSociales?.whatsapp" target="_blank">
  <img class="btn-whatsapp" src="assets/img/btn-whatsapp.png" alt="Whatsapp">
</a>
<!--  Whatsapp Button  -->
